<template>
  <div class="passsenger-data comp-app">
    <div
      id="searchOperatorUserSelection"
      class="searchOperatorUserSelection"
    ></div>
    <form
      id="data"
      name="data"
      method="post"
      action="/secure/passenger-data.xhtml?tripId=1"
      onkeypress="return event.keyCode !== 13;"
      enctype="application/x-www-form-urlencoded"
      data-partialsubmit="true"
    >
      <div
        id="passenger-form:validationsmessage"
        class="validationsmessage"
      ></div>
      <div
        class="tit-option opps management-fee-passengers bg-clr--lighter-gray u-text-align--center o-box--small u-border-radius--sm mb-10 u-display--none"
      >
        Management fee included
      </div>
      <div id="passenger-form:passengers" class="passengers pt-10">
        <h2 class="u-font-size--big u-font-weight--600 m-0">
          {{ $func.parseIso("enterTravelerData") }}
        </h2>
        <div class="pt-20">
          <div class="mb-30">
            <div
              id="passenger-form:distri:0:person:0:passengerData:passenger-data"
              class="box-form passenger-data person-0-0 o-box u-box-shadow--soft u-border-radius bg-clr--white clearfix"
            >
              <div class="o-box--tiny--horizontal">
                <h3
                  class="u-font-size--default u-font-weight--700 m-0 clr--brand"
                >
                  <i class="fa-regular fa-user"></i>&nbsp;
                  {{ $func.parseIso("primaryContact") }}
                </h3>
              </div>
              <div class="form-group u-1/1 u-4/12@sm u-float--left">
                <label
                  id="passenger-form:distri:0:person:0:passengerData:j_id_2m6"
                  class="ui-outputlabel ui-widget dev-person-name-label u-font-weight--400 u-font-size--small mt-15 ui-required"
                  for="passenger-form:distri:0:person:0:passengerData:nombre"
                >
                  {{ $func.parseIso("name")
                  }}<span class="ui-outputlabel-rfi">*</span></label
                ><input
                  type="text"
                  class="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all c-text-input u-1/1 person-name traveler-name"
                  :placeholder="$func.parseIso('name')"
                  v-model="name"
                />
              </div>
              <div class="form-group u-1/1 u-4/12@sm u-float--left">
                <label
                  id="passenger-form:distri:0:person:0:passengerData:j_id_2m6"
                  class="ui-outputlabel ui-widget dev-person-name-label u-font-weight--400 u-font-size--small mt-15 ui-required"
                  for="passenger-form:distri:0:person:0:passengerData:nombre"
                >
                  {{ $func.parseIso("lastname")
                  }}<span class="ui-outputlabel-rfi">*</span></label
                ><input
                  id="passenger-form:distri:0:person:0:passengerData:nombre"
                  name="passenger-form:distri:0:person:0:passengerData:nombre"
                  type="text"
                  class="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all c-text-input u-1/1 person-name traveler-name"
                  aria-required="true"
                  :placeholder="$func.parseIso('lastname')"
                  v-model="lastname"
                />
              </div>
              <div class="form-group u-1/1 u-4/12@sm u-float--left">
                <label
                  id="passenger-form:distri:0:person:0:passengerData:j_id_2m6"
                  class="ui-outputlabel ui-widget dev-person-name-label u-font-weight--400 u-font-size--small mt-15 ui-required"
                  for="passenger-form:distri:0:person:0:passengerData:nombre"
                >
                  {{ $func.parseIso("email")
                  }}<span class="ui-outputlabel-rfi">*</span></label
                ><input
                  id="passenger-form:distri:0:person:0:passengerData:nombre"
                  name="passenger-form:distri:0:person:0:passengerData:nombre"
                  type="text"
                  class="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all c-text-input u-1/1 person-name traveler-name"
                  aria-required="true"
                  :placeholder="$func.parseIso('email')"
                  v-model="email"
                />
              </div>
              <div class="form-group u-1/1 u-4/12@sm u-float--left">
                <label
                  id="passenger-form:distri:0:person:0:passengerData:j_id_2m6"
                  class="ui-outputlabel ui-widget dev-person-name-label u-font-weight--400 u-font-size--small mt-15 ui-required"
                  for="passenger-form:distri:0:person:0:passengerData:nombre"
                >
                  {{ $func.parseIso("cellphone")
                  }}<span class="ui-outputlabel-rfi">*</span></label
                ><input
                  id="passenger-form:distri:0:person:0:passengerData:nombre"
                  name="passenger-form:distri:0:person:0:passengerData:nombre"
                  type="text"
                  class="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all c-text-input u-1/1 person-name traveler-name"
                  aria-required="true"
                  :placeholder="$func.parseIso('cellphone')"
                  v-model="phone"
                />
              </div>
              <div class="form-group u-1/1 u-4/12@sm u-float--left">
                <label
                  id="passenger-form:distri:0:person:0:passengerData:j_id_2m6"
                  class="ui-outputlabel ui-widget dev-person-name-label u-font-weight--400 u-font-size--small mt-15 ui-required"
                  for="passenger-form:distri:0:person:0:passengerData:nombre"
                >
                  {{ $func.parseIso("country")
                  }}<span class="ui-outputlabel-rfi">*</span></label
                >
                <select
                  id="j_id_54:init-compositor-all:country"
                  name="j_id_54:init-compositor-all:country"
                  size="1"
                  class="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all c-text-input u-1/1 person-name traveler-name"
                  v-model="country"
                  style="cursor: pointer"
                  @change="checkState"
                >
                  <option :value="null">
                    {{ $func.parseIso("countrySelected") }}
                  </option>
                  <option
                    :value="item.Country"
                    v-for="item in countries"
                  >
                    {{ item.Country }}
                  </option>
                </select>
              </div>
              <div class="form-group u-1/1 u-4/12@sm u-float--left">
                <label
                  id="passenger-form:distri:0:person:0:passengerData:j_id_2m6"
                  class="ui-outputlabel ui-widget dev-person-name-label u-font-weight--400 u-font-size--small mt-15 ui-required"
                  for="passenger-form:distri:0:person:0:passengerData:nombre"
                >
                  {{ $func.parseIso("state")
                  }}<span
                    class="ui-outputlabel-rfi"
                    v-if="states.length !== 0"
                    >*</span
                  ></label
                >
                <select
                  id="j_id_54:init-compositor-all:country"
                  name="j_id_54:init-compositor-all:country"
                  size="1"
                  class="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all c-text-input u-1/1 person-name traveler-name"
                  v-model="state"
                  style="cursor: pointer"
                  :disabled="states.length === 0"
                >
                  <option :value="null">
                    {{ $func.parseIso("stateSelected") }}
                  </option>
                  <option :value="item.CODIGO" v-for="item in states">
                    {{ item.NOMBRE_ESTADO }}
                  </option>
                </select>
              </div>
              <div class="form-group u-1/1 u-4/12@sm u-float--left">
                <label
                  id="passenger-form:distri:0:person:0:passengerData:j_id_2m6"
                  class="ui-outputlabel ui-widget dev-person-name-label u-font-weight--400 u-font-size--small mt-15 ui-required"
                  for="passenger-form:distri:0:person:0:passengerData:nombre"
                >
                  {{ $func.parseIso("city")
                  }}<span class="ui-outputlabel-rfi">*</span></label
                ><input
                  id="passenger-form:distri:0:person:0:passengerData:nombre"
                  name="passenger-form:distri:0:person:0:passengerData:nombre"
                  type="text"
                  class="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all c-text-input u-1/1 person-name traveler-name"
                  aria-required="true"
                  :placeholder="$func.parseIso('city')"
                  v-model="city"
                />
              </div>
              <div class="form-group u-1/1 u-4/12@sm u-float--left">
                <label
                  id="passenger-form:distri:0:person:0:passengerData:j_id_2m6"
                  class="ui-outputlabel ui-widget dev-person-name-label u-font-weight--400 u-font-size--small mt-15 ui-required"
                  for="passenger-form:distri:0:person:0:passengerData:nombre"
                >
                  {{ $func.parseIso("address")
                  }}<span class="ui-outputlabel-rfi">*</span></label
                ><input
                  id="passenger-form:distri:0:person:0:passengerData:nombre"
                  name="passenger-form:distri:0:person:0:passengerData:nombre"
                  type="text"
                  class="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all c-text-input u-1/1 person-name traveler-name"
                  aria-required="true"
                  :placeholder="$func.parseIso('address')"
                  v-model="address"
                />
              </div>
              <div class="form-group u-1/1 u-4/12@sm u-float--left">
                <label
                  id="passenger-form:distri:0:person:0:passengerData:j_id_2m6"
                  class="ui-outputlabel ui-widget dev-person-name-label u-font-weight--400 u-font-size--small mt-15 ui-required"
                  for="passenger-form:distri:0:person:0:passengerData:nombre"
                >
                  {{ $func.parseIso("zip")
                  }}<span class="ui-outputlabel-rfi">*</span></label
                ><input
                  id="passenger-form:distri:0:person:0:passengerData:nombre"
                  name="passenger-form:distri:0:person:0:passengerData:nombre"
                  type="text"
                  class="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all c-text-input u-1/1 person-name traveler-name"
                  aria-required="true"
                  :placeholder="$func.parseIso('zip')"
                  v-model="zipcode"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="passenger-form:usaCubaExtraInfoForm:usaCubaExtraInfo"
      ></div>
      <div id="passenger-form:register:passwordRegister"></div>
      <div
        id="passenger-form:passengerBaggage:j_id_2un"
        class="ui-blockui-content ui-widget ui-widget-content ui-corner-all ui-helper-hidden ui-shadow"
      ></div>
      <div id="services-details">
        <div
          id="j_id_3m8:confirm-upgrade-selection:confirm-upgrade-selection"
          class="c-modal confirm-upgrade-selection u-zindex--1051"
          data-size="small"
          role="dialog"
          data-closeable="true"
          tabindex="-1"
          aria-modal="true"
          data-active="false"
        >
          <div class="c-modal__backmask"></div>
        </div>
        <div
          id="remark-box"
          class="o-block o-block--middle mt-40"
          v-if="week && week.ImportantNotesSP"
        >
          <div class="o-block__item">
            <div
              class="clr--warning o-flexbox u-align-items--center u-gap--small"
            >
              <h2
                class="u-display--inline-block u-font-size--big u-font-weight--600 m-0"
                style="color: #f7418f"
              >
                {{ $func.parseIso("importantInformation") }}
              </h2>
            </div>
          </div>
          <div
            class="o-block o-block--middle o-box c-alert--warning u-box-shadow--soft u-border-radius"
            style="color: #d25380; background-color: #f7418f"
          >
            <ul class="bf-feature o-block__item o-box bg-clr--white">
              <li
                style="text-align: justify"
                v-html="
                  iso === 'es'
                    ? week.ImportantNotesSP
                    : week.ImportantNotesEN
                "
              ></li>
              <br />
              <p>{{ $func.parseIso("infoImportan__msg1") }}</p>
            </ul>
          </div>
        </div>
      </div>
    </form>
    <div
      id="passengerDataConditionsAccept"
      class="passengerDataConditionsAccept o-box u-border-radius u-box-shadow--soft bg-clr--white mt-40"
    >
      <div
        id="vecipymesmodal"
        class="c-modal vecipymesmodal"
        data-size="large"
        role="dialog"
        data-closeable="true"
        tabindex="-1"
        aria-modal="true"
        data-active="false"
      >
        <div
          class="c-modal__backmask"
          onclick="$('.vecipymesmodal').modal('hide')"
        ></div>
        <div class="c-modal__wrapper">
          <div class="c-modal__container">
            <div class="c-modal__close" style="">
              <button
                type="button"
                class="c-modal__close-btn"
                data-dismiss="modal"
              >
                <span
                  class="o-box--small--horizontal o-box--tiny--vertical u-font-weight--500 u-font-size--small u-border-radius--sm u-line-height--1 u-pointer-events--none"
                >
                  Close
                  <i
                    class="fa-solid fa-caret-right u-font-size--default"
                  ></i></span
                ><i class="u-display--block fa-regular fa-close"></i>
              </button>
            </div>
            <div class="c-modal__body">
              <div
                class="c-modal__header u-font-weight--600 u-line-height--1 u-hide-empty"
              >
                Personal data information
              </div>
              <div class="o-block o-block--small">
                <div class="o-block__item">
                  <h4 class="mb-5"><b>GENERAL CONDITIONS</b></h4>
                  ???web.vecipymes.general.conditions???
                </div>
                <div class="o-block__item">
                  <h4 class="mb-5">
                    <b>???web.vecipymes.cancel.conditions.title???</b>
                  </h4>
                  ???web.vecipymes.cancel.conditions???
                </div>
                <div class="o-block__item">
                  <h4 class="mb-5">
                    <b>???web.vecipymes.economic.conditions.title???</b>
                  </h4>
                  ???web.vecipymes.economic.conditions???
                </div>
                <div class="o-block__item">
                  <h4 class="mb-5">
                    <b>???web.vecipymes.payment.conditions.title???</b>
                  </h4>
                  ???web.vecipymes.payment.conditions???
                </div>
                <div class="o-block__item">
                  <h4 class="mb-5">
                    <b
                      >INTEGRITY, BUSINESS CONDUCT AND REGULATORY
                      COMPLIANCE.</b
                    >
                  </h4>
                  ???web.vecipymes.integrity.conditions???
                </div>
                <div class="o-block__item">
                  <h4 class="mb-5">
                    <b>???web.vecipymes.data.protection.title???</b>
                  </h4>
                  ???web.vecipymes.data.protection???
                </div>
                <div class="o-block__item">
                  <h4 class="mb-5">
                    <b>???web.vecipymes.insurance.conditions.title???</b>
                  </h4>
                  ???web.vecipymes.insurance.conditions???
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h5>
        <i class="fa-regular fa-info-circle mr-5"></i
        ><b>{{ $func.parseIso("termsAndConditions") }}</b>
        <span class="clr--warning" style="color: #f7418f"
          ><em> {{ $func.parseIso("mandatory") }}</em></span
        >
      </h5>
      <div class="mb-5">
        <div
          id="general-conditions:gdprconsentmodal"
          class="c-modal gdprconsentmodal"
          data-size="medium"
          role="dialog"
          data-closeable="true"
          tabindex="-1"
          aria-modal="true"
          data-active="false"
        >
          <div
            class="c-modal__backmask"
            onclick="$('.gdprconsentmodal').modal('hide')"
          ></div>
          <div class="c-modal__wrapper">
            <div class="c-modal__container">
              <div class="c-modal__close" style="">
                <button
                  type="button"
                  class="c-modal__close-btn"
                  data-dismiss="modal"
                >
                  <span
                    class="o-box--small--horizontal o-box--tiny--vertical u-font-weight--500 u-font-size--small u-border-radius--sm u-line-height--1 u-pointer-events--none"
                  >
                    Close
                    <i
                      class="fa-solid fa-caret-right u-font-size--default"
                    ></i></span
                  ><i class="u-display--block fa-regular fa-close"></i>
                </button>
              </div>
              <div class="c-modal__body">
                <div
                  class="c-modal__header u-font-weight--600 u-line-height--1 u-hide-empty"
                >
                  Personal data information
                </div>
                <div class="u-line-break--anywhere">-</div>
              </div>
            </div>
          </div>
        </div>
        <div class="o-flexbox u-gap--small">
          <input
            id="general-conditions:generaltermsConsent"
            type="checkbox"
            name="general-conditions:generaltermsConsent"
            :value="true"
            class="condiciones must-check c-checkbox"
            data-message="You must accept the remarks and cancellation costs before you continue with the booking process"
            autocomplete="off"
            style="cursor: pointer"
            v-model="terms"
          />
          <div>
            <label
              class="u-display--inline u-font-weight--400"
              for="general-conditions:generaltermsConsent"
            >
              {{ $func.parseIso("msgTermsAndConditions") }}
            </label>
          </div>
        </div>
      </div>
      <div
        id="general-conditions:modal-conditions-error"
        class="c-modal modal-conditions-error c-modal-alert u-text-align--center"
        data-size="small"
        role="dialog"
        data-closeable="true"
        tabindex="-1"
        aria-modal="true"
        data-active="false"
      >
        <div
          class="c-modal__backmask"
          onclick="$('.modal-conditions-error').modal('hide')"
        ></div>
        <div class="c-modal__wrapper">
          <div class="c-modal__container">
            <div class="c-modal__close" style="">
              <button
                type="button"
                class="c-modal__close-btn"
                data-dismiss="modal"
              >
                <span
                  class="o-box--small--horizontal o-box--tiny--vertical u-font-weight--500 u-font-size--small u-border-radius--sm u-line-height--1 u-pointer-events--none"
                >
                  Close
                  <i
                    class="fa-solid fa-caret-right u-font-size--default"
                  ></i></span
                ><i class="u-display--block fa-regular fa-close"></i>
              </button>
            </div>
            <div class="c-modal__body">
              <div
                class="c-modal__header u-font-weight--600 u-line-height--1 u-hide-empty"
              ></div>
              <div class="o-block o-block--small">
                <b
                  class="o-block__item u-font-size--big u-text-transform--capitalize--first-letter"
                  >Warning</b
                >
                <div class="o-block__item">
                  You must accept the remarks and cancellation costs
                  before you continue with the booking process
                </div>
                <div class="o-block__item">
                  <a
                    type="button"
                    class="c-button bg-clr--brand"
                    data-dismiss="modal"
                    aria-hidden="true"
                  >
                    OK
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </div>
    <div
      id="form"
      name="form"
      method="post"
      action="/secure/passenger-data.xhtml?tripId=1"
      enctype="application/x-www-form-urlencoded"
      data-partialsubmit="true"
    >
      <div
        class="register-button o-flexbox o-flexbox--generic-row u-gap--small mt-20"
      >
        <div class="u-flex--11 u-flex--none@sm">
          <a
            @click="$emit('back')"
            class="register-button--back c-button c-button--lg@sm bdr-clr--brand mb-10"
          >
            {{ $func.parseIso("back") }}
          </a>
        </div>
        <div class="u-flex--11 u-flex--none@sm">
          <button
            id="form:j_id_4lh"
            name="form:j_id_4lh"
            class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only c-button--continue c-button c-button--lg@sm bg-clr--brand"
            @click="hold"
          >
            <span class="ui-button-text ui-c">{{
              $func.parseIso("next")
            }}</span>
          </button>
        </div>
      </div>
    </div>
    <Alert :show="alert.show" :title="alert.title" :closeAlert="alert.close" />
  </div>
</template>

<script>
import Alert from "./Alert.vue";
import { getSesion } from "../utils/sesions";

export default {
  props: {
    week: { type: Object, default: null },
    iso: { type: String, default: "es" },
    numberRef: { type: String, default: null },
  },
  data() {
    return {
      countries: [],
      states: [],
      name: null,
      lastname: null,
      email: null,
      phone: null,
      address: null,
      city: null,
      state: null,
      zipcode: null,
      country: null,
      terms: false,
      loading: false,
      alert: {
        show: false,
        title: null,
        description: null,
        close: null,
      },
    };
  },
  components: {
    Alert,
  },
  async created() {
    await this.listCountries();
  },
  methods: {
    async listCountries() {
      try {
        const { data } = await this.$axios.get("/week/countries-all");
        this.countries = data.countries;
        this.countries = this.countries.sort((a, b) =>
          a.Country === "USA" ||
          a.Country === "Mexico" ||
          a.Country === "Dominican Republic"
            ? -1
            : 0
        );
      } catch (error) {
        console.log(error);
      }
    },
    async checkState() {
      if (this.country) {
        const c = this.countries.find((c) => c.Country === this.country);
        if (c && c.TIPO > 0) {
          await this.listState();
        } else {
          this.state = null;
          this.states = [];
        }
      } else {
        this.state = null;
        this.states = [];
      }
    },
    async listState() {
      try {
        const { data } = await this.$axios.get(
          `/week/states/all?country=${this.country}`
        );
        this.states = data.states;
      } catch (error) {
        console.log(error);
      }
    },
    checkClient() {
      let pass = true;
      let msg = "";

      const rgxOnlyTextAndSpace = /^[a-zA-Z \u00C0-\u024F\u1E00-\u1EFF]*$/;
      const rgxEmail = /^[a-z0-9\._+\-]+@([a-z0-9\-]+\.){1,}([a-z]{2,16})*$/;

      if (
        !this.name ||
        !this.lastname ||
        !this.email ||
        !this.phone ||
        !this.country ||
        !this.city ||
        !this.address ||
        !this.zipcode ||
        !this.terms
      ) {
        pass = false;
        msg = this.$func.parseIso("allFieldsRequired");
      }

      if (!this.terms) {
        pass = false;
        msg = this.$func.parseIso("acceptTerms");
      }

      if (this.country) {
        const country = this.countries.find((c) => c.Country === this.country);
        if (country && country.TIPO > 0 && !this.state) {
          pass = false;
          msg = this.$func.parseIso("fieldStateRequired");
          msg = msg.replace("{{country}}", this.country);
        }
      }
      if (this.name && !rgxOnlyTextAndSpace.test(this.name)) {
        pass = false;
        msg = this.$func.parseIso("fieldOnlyLettersAndSpaces");
        msg = msg.replace("{{field}}", this.$func.parseIso("name"));
      }
      if (this.lastname && !rgxOnlyTextAndSpace.test(this.lastname)) {
        pass = false;
        msg = this.$func.parseIso("fieldOnlyLettersAndSpaces");
        msg = msg.replace("{{field}}", this.$func.parseIso("lastname"));
      }
      if (this.email && !rgxEmail.test(this.email)) {
        pass = false;
        msg = this.$func.parseIso("emailInvalid");
      }

      return { pass, msg };
    },
    async hold() {
      try {
        const { pass, msg } = this.checkClient();
        if (pass && !this.loading) {
          this.loading = true;
          const sesionTC = getSesion();
          const payload = {
            name: this.name,
            lastname: this.lastname,
            email: this.email,
            phone: this.phone,
            address: this.address,
            city: this.city,
            state: this.state || "",
            zipcode: this.zipcode,
            country: this.country,
            iso: this.iso || "es",
            loginId: sesionTC?.LoginID || null,
          };
          await this.$axios.post(`/week/add-traveler/hold/${this.numberRef}`, payload);
          this.$emit("hold-success", payload);
        } else {
          this.alert.title = msg;
          this.alert.close = this.closeAlert;
          this.openAlert();
        }
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    openAlert() {
      this.alert.show = true;
    },
    closeAlert() {
      this.alert.show = false;
    },
  },
};
</script>
